import { AfterViewInit, Component, TemplateRef, ViewChild } from '@angular/core'
import { MatDialogConfig, MatDialogRef } from '@angular/material/dialog'
import { ModalService } from '@app/modal/modal.service'
import { TermosResidenteService } from '../../service/residente/termos-residente.service'

@Component({
  selector: 'app-termos-residente',
  templateUrl: './termos-residente.component.html',
})
export class TermosResidenteComponent implements AfterViewInit {
  constructor(private modalService: ModalService, private confirmacaoService: TermosResidenteService) {}

  @ViewChild('modal') component: TemplateRef<any>
  private modal: MatDialogRef<any>

  ngAfterViewInit(): void {
    this.confirmacaoService.getAceito().subscribe((aceito) => !aceito && this.openModal())
  }

  openModal(): void {
    let dialogConfig = new MatDialogConfig()
    dialogConfig.width = '42em'
    dialogConfig.disableClose = true
    this.modal = this.modalService.openCustomComponentModal(this.component, dialogConfig)
  }

  onSubmit(): void {
    this.confirmacaoService.saveAceitouTermos().subscribe(() => this.closeModal())
  }

  private closeModal(): void {
    this.modal.close()
  }
}
